export function useEachRecursively(
	items,
	callback
) {
	items.forEach(async item => {
		const skipRef = { skip: false }
		callback(item, skipRef)
		if (skipRef.skip) return
		if (!item.children?.length) return

		useEachRecursively(item.children, callback)
	})
}
